// Keep the mobile navigation operable for pointer and keyboard users.
export default function menuOpen() {
	const burgerButton = document.querySelector(".gh-burger");
	const menu = document.querySelector("#gh-head-menu");
	if (!burgerButton || !menu) return;

	const setOpen = (open, { restoreFocus = false } = {}) => {
		document.body.classList.toggle("gh-head-open", open);
		burgerButton.setAttribute("aria-expanded", String(open));
		burgerButton.setAttribute("aria-label", open ? "Close menu" : "Open menu");

		if (open) {
			menu.querySelector("a")?.focus();
		} else if (restoreFocus) {
			burgerButton.focus();
		}
	};

	burgerButton.addEventListener("click", () => {
		setOpen(!document.body.classList.contains("gh-head-open"));
	});

	document.addEventListener("keydown", (event) => {
		if (
			event.key === "Escape" &&
			document.body.classList.contains("gh-head-open")
		) {
			setOpen(false, { restoreFocus: true });
		}
	});

	menu.addEventListener("click", (event) => {
		if (event.target.closest("a")) setOpen(false);
	});
}
